// Цветовые стили тарифов. Значения живут в палитре темы
// (src/lib/themePalette.js, семейство tier-*), здесь — только роли.
// На голубой теме раскладка прежняя: FREE — голубой, ЛАЙТ — сиреневый,
// ПРО и ПРО навсегда — розовый. На сиреневой теме витрина выстроена
// лесенкой «чем дороже, тем заметнее»: FREE нейтральный серо-сиреневый,
// ЛАЙТ — основной сиреневый, ПРО — золото 500/600, навсегда — золото 700/800.
// Используются на новой главной (3 плашки: FREE, ПРО, ПРО навсегда) и
// страницах категорий. Стиль ASTROFEEL остаётся — им красятся бейджи
// ЛАЙТ-программ в каталоге и шапке, хотя отдельной плашки на витрине нет.
export const TIER_STYLES = {
  FREE: {
    shortLabel: 'FREE',
    accessHint: 'Доступно бесплатно',
    cardBg: 'bg-tier-free-bg',
    cardBorder: 'border-tier-free-border',
    badgeBg: 'bg-tier-free-badge',
    badgeText: 'text-tier-free-badge-text',
    btnClass: 'bg-tier-free-btn hover:bg-tier-free-btn-hover text-white rounded-lg',
  },
  ASTROFEEL: {
    shortLabel: 'Пробный доступ',
    accessHint: '14 дней бесплатно после регистрации',
    cardBg: 'bg-tier-light-bg',
    cardBorder: 'border-tier-light-border',
    badgeBg: 'bg-tier-light-badge',
    badgeText: 'text-tier-light-badge-text',
    btnClass: 'bg-tier-light-btn hover:bg-tier-light-btn-hover text-white rounded-lg',
  },
  PRO: {
    shortLabel: 'ПРО',
    accessHint: 'Доступно на тарифе ПРО',
    cardBg: 'bg-tier-pro-bg',
    cardBorder: 'border-tier-pro-border',
    badgeBg: 'bg-tier-pro-badge',
    badgeText: 'text-tier-pro-badge-text',
    btnClass: 'bg-tier-pro-btn hover:bg-tier-pro-btn-hover text-white rounded-lg',
  },
  PRO_FOREVER: {
    shortLabel: 'ПРО навсегда',
    accessHint: 'Тариф ПРО навсегда',
    cardBg: 'bg-tier-master-bg',
    cardBorder: 'border-tier-master-border',
    badgeBg: 'bg-tier-master-badge',
    badgeText: 'text-tier-master-badge-text',
    btnClass: 'bg-tier-master-btn hover:bg-tier-master-btn-hover text-white rounded-lg',
  },
};

// pricing.id (из homepageContent.json) → ключ тарифа
export const PRICING_ID_MAP = {
  free: 'FREE',
  astrofeel: 'ASTROFEEL',
  pro: 'PRO',
  'pro-forever': 'PRO_FOREVER',
};

export function tierStyle(key) {
  return TIER_STYLES[key] || TIER_STYLES.FREE;
}
